import {
  OrganizationsInput,
  OrganizationsOutput,
  UserRoles,
} from "../interfaces/organizations";
import { BaseService, QueryParams } from "./BaseService";

export class OrganizationService extends BaseService<
  OrganizationsInput,
  OrganizationsOutput
> {
  constructor() {
    super();
    this.path = "organizations";
  }

  async getByUsers(
    userId: string,
    queryParams?: QueryParams,
    options?: RequestInit
  ) {
    const url = `users/${userId}/${this.path}`;
    return (await this.request(url, {
      ...options,
      queryParams,
      method: "GET",
    })) as OrganizationsOutput[];
  }

  async addUser(organizationId: string, userId: string, options?: RequestInit) {
    const url = `${this.path}/${organizationId}/members/${userId}`;
    return (await this.request(url, {
      ...options,
      method: "POST",
    })) as OrganizationsOutput[];
  }

  async removeUser(
    organizationId: string,
    userId: string,
    options?: RequestInit
  ) {
    const url = `${this.path}/${organizationId}/members/${userId}`;
    return (await this.request(url, {
      ...options,
      method: "DELETE",
    })) as OrganizationsOutput[];
  }

  async updateUserRole(
    organizationId: string,
    userId: string,
    role: UserRoles,
    options?: RequestInit
  ) {
    const url = `${this.path}/${organizationId}/members/${userId}`;
    return (await this.request(url, {
      ...options,
      body: JSON.stringify({ role }),
      method: "PATCH",
    })) as OrganizationsOutput;
  }

  async transferOwnership(
    organizationId: string,
    userId: string,
    options?: RequestInit
  ) {
    const url = `${this.path}/${organizationId}/members/${userId}/transfer_ownership`;
    return (await this.request(url, {
      ...options,
      method: "POST",
    })) as OrganizationsOutput;
  }
}
